import { easeSnappy, durMedium } from './easings.js';
import { prefersReducedMotion } from './prefersReducedMotion.js';

/** y + opacity entrance on viewport enter. */
export default () => ({
  init() {
    if (prefersReducedMotion()) return;
    window.gsap.from(this.$el, {
      y: 28,
      // autoAlpha (opacity + visibility) so the hidden element carries
      // `visibility: hidden` and contrast checkers skip it instead of
      // flagging low-contrast text at opacity 0.
      autoAlpha: 0,
      duration: durMedium,
      ease: easeSnappy,
      scrollTrigger: { trigger: this.$el, start: 'top 85%', once: true },
    });
  },
});
